var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component",attrs:{"to":_vm.to,"disabled":_vm.disabled},on:{"click":_vm.handleClick},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},'component',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }